export default "__VITE_ASSET__0c327311__"